<template>
  <div class="user-tags">
    <div class="title">
      标签
    </div>
    <div class="tags">
      <el-tag
          style="margin-right: 3px;margin-bottom: 5px"
          size="mini"
        v-for="tag in tags"
        :key="tag.id"
        :color="tag.color"
          effect="dark"
        >
        {{tag.name}}
      </el-tag>
    </div>
  </div>
</template>

<script>

import { getUserTageByUserId } from '@/api/demo/user'
import { randomColor } from '@/utils'

export default {
  name: 'userTags',
  props: {
    accountId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tags: []
    }
  },
  watch: {
    accountId: function (newVal, oldVal) {
      this.getTags()
    }
  },
  mounted () {
    this.getTags()
  },
  methods: {
    getTags () {
      getUserTageByUserId(this.accountId).then(res => {
        for (let i = 0; i < res.length; i++) {
          res[i].color = randomColor()
        }
        console.log(res, 'tags')
        this.tags = res
      })
    }
  }
}
</script>

<style scoped>
  .title{
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .subtitle{
    font-size: 12px;
    color: #999;
    margin-bottom: 20px;
  }
</style>
